export const hentaiList = [
    {
        rank: 1,
        name: "Maid Kyouiku: Botsuraku Kizoku Rurikawa Tsubaki The Animation",
        description: "Sample Description",
        image: "https://media.discordapp.net/attachments/1070935019763290233/1448503060354695389/Maid_Kyouiku-_Botsuraku_Kizoku_Rurikawa_Tsubaki_The_Animation_-_02.mov_snapshot_07.44.809.jpg?ex=696c4699&is=696af519&hm=6871f47782f65c243d239033390e3351fabe809451391ce7eaa5587c785e7c83&=&format=webp&width=950&height=534",
        url: "#",
    },
    {
        rank: 2,
        name: "Dearest Blue",
        description: "Sample Description",
        image: "https://media.discordapp.net/attachments/1070935019763290233/1438161982913253536/Dearest_Blue_-_04.mov_snapshot_16.07.170.jpg?ex=696c3a78&is=696ae8f8&hm=33b13e6da94a524ea0307970e8881103c905bbee50ecc92dcd9b39ce09fd2b1b&=&format=webp&width=950&height=534",
        url: "#",
    },
    {
        rank: 3,
        name: "Cool de M",
        description: "Sample Description",
        image: "https://media.discordapp.net/attachments/1070935019763290233/1458842729197998242/Cool_de_M_-_01.mov_snapshot_05.27.367.jpg?ex=696c516a&is=696affea&hm=9805b89b6230e0c9303f70d7ac6f58043471db2aebcc5a447b7ede03d7b0cdf0&=&format=webp&width=950&height=534",
        url: "#",
    },
];
